import { useCallback } from 'react';
import { useApi } from './useApi';
import { useStateValue } from '../context/StateValueContext';
import type { MiniCompany } from '../types/company';

export function useRefreshCompanies() {
  const { get } = useApi();
  const [, dispatch] = useStateValue();
  return useCallback(async () => {
    try {
      const response = await get<MiniCompany[]>('/api/companies/mini');
      dispatch({ type: 'SET_MINI_COMPANIES', miniCompanies: response });
    } catch (err) {
      console.error('Failed to refresh companies:', err);
    }
  }, [get, dispatch]);
}
